module.exports = __webpack_public_path__ + "img/zip.7d946fd8.svg";